/**
 * ===============================================================================================================
 * ===============================================================================================================
 * CUSTOM CODE BY BYTES
 * ===============================================================================================================
 * ===============================================================================================================
*/


/**
 *
 * id attribute value must be unique
 *
*/

const referenceAttributes = [
  'aria-labelledby',
  'aria-controls',
  'aria-describedby',
  'for'
];
function iterateDuplicateIds() {
  let uids = Array(); // first instance of ids get put here
  let dids = Array(); // duplicate id's get put here
  const e = document.querySelectorAll('[id]'); // all elements with an id
  e.forEach(function(id, index) { // loop through them
    if(!uids.includes(id.id)) { // if the uids array doesn't already contain that id, put it in. Used to check for duplicates
      uids.push(id.id);
    } else {
      dids.push(id.id); // if a duplicate id, put it in the duplicate id array
    }
  });
  // loop through duplicate ids and
  dids.forEach(function(did, index) {
    const theseDids = document.querySelectorAll(`#${did}`);
    theseDids.forEach(function(d, i) { // loop through all elements that use a duplicate id
      if(i > 0) { // don't touch the first instance
        const origID = d.id;
        const newID = d.id + i;
        d.setAttribute('id', newID);
        referenceAttributes.forEach(function(ref, o) { // loop through attribute references to the duplicate id
          document.querySelectorAll(`[${ref}=${origID}]`).forEach(function(r, p) { // loop through each element containing that attribute reference to the duplicated id
            if( p > 0 ) { // ignore the first instance, saved for the untouched first instance of the id
              r.setAttribute(ref, newID); // set the attributes reference to the new ID
            }
          });
        })
      }
    });
  });
}
iterateDuplicateIds(); // on load
setTimeout(function() {
  iterateDuplicateIds(); // get other stuff that loads later
}, 2000);



/**
 * <ul> and <ol> must only directly contain <li>, <script> or <template> elements
*/
const acceptedListChildren = ['LI', 'SCRIPT', 'TEMPLATE'];
const listElements = document.querySelectorAll('ul, ol');
if(listElements) {
  listElements.forEach(function(list, index) {
    // console.log(list);
    const listChildren = list.childNodes;
    listChildren.forEach(function(child, i) {
      if(!acceptedListChildren.includes(child.nodeName) && ( child.nodeName !== '#text' && child.wholeText !== '\n' )) {
        const newLI = document.createElement('li');
        child.insertAdjacentElement('afterend', newLI);
        newLI.insertAdjacentElement('afterbegin', child);
        if(!child.innerHTML) {
          newLI.style = "display:none;";
        }
      }
    })
  });
}